import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Common } from '../../utils/common';
import DataTable from '../reporting_utils/DataTable';

function DNICampaignsTable({ tableData }) {
  const [isOpen, setIsOpen] = useState(true);

  return (
    <>
      <div
        className='numbers_and_features_table_header'
        role='button'
        onClick={() => setIsOpen(!isOpen)}
      >
        <i className={isOpen ? 'fa fa-caret-down' : 'fa fa-caret-right'} /> DNI Campaigns
      </div>
      <div hidden={!isOpen} className='table-responsive' style={{ paddingBottom: '30px' }}>
        <DataTable
          columnDefs={columnBuilder()}
          data={tableData}
          title='DNI Campaigns'
          showTotalFooter={false}
        />
      </div>
    </>
  );
}

function columnBuilder() {
  const columns = [];
  columns.push({ data: 'domain_id', title: 'Domain ID', visible: false });
  columns.push({ data: 'group_id', title: 'Group ID', visible: false });
  columns.push({ data: 'location_name', title: 'Location Name' });
  columns.push({ data: 'campaign_name', className: '', title: 'Campaign Name' });
  columns.push({ data: 'did_count', className: 'text-center', title: 'DID Count' });
  columns.push({
    data: 'default_target_number',
    className: 'text-center',
    title: 'Default Target',
    render: (data, type, row) =>
      row.target_type == 'DEFAULT' ? Common.formatPhoneNumber(data) : 'N/A',
  });
  columns.push({
    data: 'treatment_name',
    className: '',
    render: (data, type, row) => (row.target_type != 'DEFAULT' ? data : 'None'),
    title: 'Treatment Name',
  });
  columns.push({
    data: 'has_call_recording',
    render: (data, type) => {
      let className = data == 0 ? 'glyphiconno glyphicon-remove' : 'glyphiconyes glyphicon-ok';
      return type == 'display' ? `<i class='${className}'></i>` : data;
    },
    title: 'Call Recording',
  });
  columns.push({
    data: 'call_disclaimer',
    visible: false,
    render: (data, type) => {
      if (data == 0) {
        return 'None';
      } else if (data == 1) {
        return 'English';
      } else if (data == 2) {
        return 'Spanish';
      } else if (data == 3) {
        return 'French';
      }
    },
    title: 'Call Disclaimer',
  });
  columns.push({
    data: 'text_enabled_count',
    render: (data, type) => {
      let className = data == 0 ? 'glyphiconno glyphicon-remove' : 'glyphiconyes glyphicon-ok';
      return type == 'display' ? `<i class='${className}'></i>` : data;
    },
    title: 'Texting Enabled',
  });
  columns.push({
    data: 'has_transcription',
    render: (data, type) => {
      let className = data == 0 ? 'glyphiconno glyphicon-remove' : 'glyphiconyes glyphicon-ok';
      return type == 'display' ? `<i class='${className}'></i>` : data;
    },
    title: 'Speech Transcription',
  });
  columns.push({
    data: 'has_repcode',
    visible: false,
    render: (data, type) => {
      let className = data == 0 ? 'glyphiconno glyphicon-remove' : 'glyphiconyes glyphicon-ok';
      return type == 'display' ? `<i class='${className}'></i>` : data;
    },
    title: 'Rep Code',
  });
  columns.push({
    data: 'has_webhook',
    visible: false,
    render: (data, type) => {
      let className = data == 0 ? 'glyphiconno glyphicon-remove' : 'glyphiconyes glyphicon-ok';
      return type == 'display' ? `<i class='${className}'></i>` : data;
    },
    title: 'Webhook',
  });
  columns.push({
    data: 'has_redaction',
    render: (data, type) => {
      let className = data == 0 ? 'glyphiconno glyphicon-remove' : 'glyphiconyes glyphicon-ok';
      return type == 'display' ? `<i class='${className}'></i>` : data;
    },
    title: 'Redaction',
  });
  columns.push({
    data: 'has_dealsaver',
    render: (data, type) => {
      let className = data == 0 ? 'glyphiconno glyphicon-remove' : 'glyphiconyes glyphicon-ok';
      return type == 'display' ? `<i class='${className}'></i>` : data;
    },
    title: 'DealSaver',
  });
  columns.push({
    data: 'has_leadscore',
    render: (data, type) => {
      let className = data == 0 ? 'glyphiconno glyphicon-remove' : 'glyphiconyes glyphicon-ok';
      return type == 'display' ? `<i class='${className}'></i>` : data;
    },
    title: 'LeadScore',
  });
  columns.push({
    data: 'has_callshield',
    render: (data, type) => {
      let className = data == 0 ? 'glyphiconno glyphicon-remove' : 'glyphiconyes glyphicon-ok';
      return type == 'display' ? `<i class='${className}'></i>` : data;
    },
    title: 'CallShield',
  });
  columns.push({
    data: 'has_email',
    visible: false,
    render: (data, type) => {
      let className = data == 0 ? 'glyphiconno glyphicon-remove' : 'glyphiconyes glyphicon-ok';
      return type == 'display' ? `<i class='${className}'></i>` : data;
    },
    title: 'Email',
  });
  columns.push({
    data: 'texting_team_name',
    visible: false,
    className: '',
    render: (data) => (data ? data : 'None'),
    title: 'SMS Team',
  });

  return columns;
}

DNICampaignsTable.propTypes = {
  tableData: PropTypes.array.isRequired,
};

export default DNICampaignsTable;
